import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { MasterService } from '../../@core/services/master.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { log } from 'console';
import { NbToastrService } from '@nebular/theme';
import { ExportService } from '../../@core/services/export.service';
import { interval } from 'rxjs';
import { MenuService } from '../pages-menu';
import * as pdfjsLib from 'pdfjs-dist';
// Setup the worker
(pdfjsLib as any).GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${(pdfjsLib as any).version}/pdf.worker.min.js`;




@Component({
  selector: 'ngx-dashboard-engineer',
  templateUrl: './dashboard-engineer.component.html',
  styleUrls: ['./dashboard-engineer.component.scss']
})
export class DashboardEngineerComponent implements OnInit, OnDestroy {
  @ViewChild('upload_input', { static: false }) uploadInputRef!: ElementRef;
  @ViewChild('upload_avd_input') uploadAvdInputRef!: ElementRef;
  private destroy$ = new Subject<void>();
  private refreshSubscription$ = new Subject<void>();
  form: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  paginatestartIndex:number = 0
  paginateendIndex:number = 10
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  fromRfqDate:any = '';
  toRfqDate:any = '';
  selectedRfqDate: any = "";
  showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false; // RFQ modal visibility flag

  fromExpectedCompletionDate: any = '';
  toExpectedCompletionDate: any = '';
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  sourcingListFiles: File[] = [];
  alternatePartFiles: File[] = [];
  allManufacturerDetails: any[] = [];
  finalDataList:any = [];
  isUploadEnabled: boolean = false; // Initially, the Upload button is disabled.
  // Criteria object to hold form data
  criteria = {
    stockAvailability: false,
    leadTime: false,
    minimumPrice: false,
    authorisedSuppliers: false,
    selectedSuppliers: [],
  };
  // projectNameDetails: any[];
  projectNameDetails: string[] = []; 

  buttonColorMap: { [key: string]: string } = {};

  allManufacturerDetailsMap: { [key: string]: any[] } = {};
  isButtonHidden: { [key: string]: boolean } = {};

  showDropdownMap: { [key: string]: boolean } = {};
  selectedManufacturer: { [key: string]: string } = {};  // Store selected manufacturer
  buttonBorderStyle: { [key: string]: string } = {};  // Store border styles
  isDropdownVisible: { [key: string]: boolean } = {};
  selectedManufacturerMap: { [key: string]: string } = {};
  manufacturerOverrideMap: { [key: string]: string } = {};
  thisMonthProjects: any[] = [];
  isHeaderMappingRequired: boolean = false;
  headerErrorMessage: string = '';


  // Mock data for supplier dropdown
  supplierOptions = [
    { id: 1, name: 'DigiKey' },
    { id: 2, name: 'element14 APAC' },
    { id: 3, name: 'Mouser' },
    { id: 4, name: 'Arrow Electronics' },
    { id: 5, name: 'FDH Electronics' },
    { id: 6, name: 'Heilind Electronics' },
    { id: 7, name: 'Onlinecomponents.com' },
    { id: 8, name: 'RS (Formerly Allied Electronics)' },
    { id: 9, name: 'TTI' },
    { id: 10, name: 'TME' },
    { id: 11, name: 'Future Electronics' },
  ];
  parts: any;
  userId: string | null;
  role: string | null;
  openStatusCount: number;
  overdueCount: number;
  allOpenProjectDetails: any;
  allCustomerDetails: any;

  sourcingDummyData = [
    {
      "Customer Part No.": "461500500155",
      "Internal Part No.": "461500500155",
      "Description": "CON CIRS THD PL ST M3/22A SLD",
      "Specification": "MS3106F10SL-3P/TB3106FW-10SL-3PNC",
      "Commodity": "Connectors",
      "Manufacturer(Mfg)": "AMPHENOL AEROSPACE/ALLIED ELECTRONICS CORPORATION/TURBO INDIA INTERCONNECT",
      "UOM": "EA",
      "Project qty": 12.0,
      "I Sourcing": "Yes"
    },
  ];

  avdDummyData = [
    {
      "Internal Part No.": "461517560515",
      "Manufacturer(Mfg)": "ODU GMBH & CO. KG",
      "Specification": "G80YAR-P04WFG0-000L"
    }
  ];
  version_id: any;
  selectedProjectId: any;
  selectedVersionId: any = null;
  finalCompareDataList: any[];
  selectedProjectName: string = '';
  showProjectDropdown: boolean = false;
  filteredProjectNames: string[] = [];
  filteredSourceListData: any[];
  paginatedData: any[] = []; // Subset to show in table
  rowsPerPage = 10; // Default rows per page
  pageSizeOptions = [10, 20, 50, 'All']; // Dropdown options
  // totalPages: any;
  created_by_id: number;
  selectedRowProjectId: number;
  projectRowDetailsWithVersionId: any;
  socket: WebSocket;
  isUploading = false;
  isRefresh = false; // Show refresh loader
  uploadedHeaders: string[] = [];
fieldMapping: any //{ [key: string]: string }
 = {}; // User-defined mapping
reverseFieldMapping: any //{ [key: string]: string } 
= {}; 
expectedFields = [
  { key: 'customerPartNumber', label: 'Customer Part No.' },
  { key: 'internalPartNo', label: 'Internal Part No.' },
  { key: 'description', label: 'Description' },
  { key: 'specification', label: 'Specification' },
  { key: 'commodity', label: 'Commodity' },
  { key: 'manufacturer', label: 'Manufacturer(Mfg)' },
  { key: 'uom', label: 'UOM' },
  { key: 'projectQty', label: 'Project qty' },
  { key: 'iSourcing', label: 'I Sourcing' },
];





applyMappedData() {
  this.sourceListData = [];

  for (let row of this.data) {
    let rowO:any = row
    let mappedRow: any = {};

    this.tableHeaders.forEach(header => {
      const uploadedHeader:any = this.reverseFieldMapping[header.key];

      if (uploadedHeader) {
        let val:any = rowO[uploadedHeader];

        if (header.key === 'projectQty') {
          // if no value, keep undefined instead of 0
          mappedRow[header.key] = val !== undefined && val !== null && val !== '' 
            ? Number(val) 
            : undefined;
        } else {
          // keep undefined if nothing mapped
          mappedRow[header.key] = val !== undefined && val !== null && val !== '' 
            ? String(val).trim() 
            : undefined;
        }
      } else {
        // dropdown not selected → undefined
        mappedRow[header.key] ="Undefined";
      }
    });

    this.sourceListData.push(mappedRow);
  }

  if (this.avdData.length === 0) {
    this.finalDataList = this.sourceListData;
  }

  console.log(" Final Mapped Data:", this.sourceListData);
}




  
  saveModal() {
    console.log('Selected Criteria:', this.criteria);
   
    this.finalDataList = this.finalDataList.map(item => ({
      ...item, // Copy existing properties
      stockAvailability: Number(this.criteria.stockAvailability) >= 0 ? Number(this.criteria.stockAvailability) : 0,
      leadTime: this.criteria.leadTime ? 1 : 0,
      minimumPrice: Number(this.criteria.minimumPrice) >= 0 ? Number(this.criteria.minimumPrice) : 0,
      authorisedSuppliers: this.criteria.authorisedSuppliers ? 1 : 0,

      // suppliers: [
      //   'supplierName': (this.criteria.selectedSuppliers) ? (this.criteria.selectedSuppliers) : [],        
      // ],
      suppliers: this.criteria.selectedSuppliers
        ? this.criteria.selectedSuppliers.map(supplier => ({
          supplierName: supplier,
        }))
        : [],


    }));

    // alert('Criteria saved successfully!');
    console.log('finalDataList', this.finalDataList);
    setTimeout(() => {
      this.closeModal();
    }, 100)
  }


  toggleDatePicker() {
    this.isDatePickerOpen = !this.isDatePickerOpen;
  }
  isDatePickerOpen = false;
  displayDate(): string {
    if (this.fromDate && this.toDate) {
      return `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day} to ${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
    } else if (this.fromDate) {
      return `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
    }
    return '';
  }


  allCustomerData = [];
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string;
  incorUploadFiles: any[];
  selectedIncorFile: any;
  data:any;
  dataProp: string[];
  sourceListData:any = [];
  avdData:any = [];
  sourcingListFileName: string = '';
  upload_input: any;
  alternatePartFileName: string = '';
  upload_avd_input: any;
  progressPercentage: string = '0';
  

  tableHeaders = [
    { key: "SlNo", label: "Sl No." },
    { key: "customerPartNumber", label: "Customer Part Number" },
    { key: "internalPartNo", label: "Internal Part Number" },
    { key: "description", label: "Description" },
    { key: "specification", label: "Specification" },
    { key: "commodity", label: "Commodity" },
    { key: "manufacturer", label: "Manufacturer(Mfg)" },
    { key: "uom", label: "UOM" },
    { key: "projectQty", label: "Project Quantity" },
    { key: "iSourcing", label: "I-Sourcing" }
  ];


  showSearch = false;
  showSearchRow: boolean[] = new Array(this.tableHeaders.length).fill(false); // Track column visibility
  searchValues: string[] = new Array(this.tableHeaders.length).fill(""); // Holds search input values
  

  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private notify: NbToastrService,
    private exportService: ExportService,
    private menuService: MenuService,
    private cdRef: ChangeDetectorRef
  ) {

   }


  ngOnInit(): void {
    this.userId = '';
    this.role = ''
    this.form = this.f_builder.group({
      source_file_name: [''],
      sourcingListFileName: [''],
      alternatePartFileName: [''],

    });
    this.userId = sessionStorage.getItem('user_id'); // Retrieves session user_id
    this.role = sessionStorage.getItem('role');     // Retrieves role    

    this.getAllcustomers();
    this.getAllOpenProjectData();
    

  }
receiveData(){
  let receiveData:any = history.state
    console.log('receiveData => ', receiveData, receiveData?.currentPage)
    if(receiveData){
      if(receiveData.hasOwnProperty('rowsPerPage')){
      this.rowsPerPage = !!receiveData ?  receiveData.rowsPerPage : 10
      }
      if(receiveData.hasOwnProperty('currentPage')){
      this.currentPage = !!receiveData ?  receiveData.currentPage : 1
       this.paginate();
      }

    }
    history.replaceState({}, '')
}

  today: Date = new Date();
  calculateAgeing(assignedDate: string, status: string, closedDate?: string): number {
    const assignedDateObj = new Date(assignedDate);
    let endDate: Date;

    if (status === 'Closed' && closedDate) {
      endDate = new Date(closedDate);
    } else {
      endDate = new Date();
    }

    const timeDifference = endDate.getTime() - assignedDateObj.getTime();
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }
  openHeaderMappingModal(content) {
  this.modalService.open(content, { size: 'lg', backdrop: 'static' });
}
isECDGreaterThanToday(dateString: string | Date): boolean {
  if (!dateString) return false;
  const today = new Date();
  const ecdDate = new Date(dateString);
  return ecdDate < today;
}



  filterProjectNames() {
  const input = this.selectedProjectName.toLowerCase();
  this.filteredProjectNames = this.projectNameDetails.filter(name =>
    name.toLowerCase().includes(input)
  );
}

selectProjectName(name: string) {
  this.selectedProjectName = name;
  this.showProjectDropdown = false;
  this.onSelectProject();  
}

hideDropdown() {
  
  setTimeout(() => {
    this.showProjectDropdown = false;
  }, 200);
}

  getThisMonthProjects() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    this.thisMonthProjects = this.matchedCustomerData.filter(group => {
      const rfqDate = new Date(group.rfqDate);
      return rfqDate.getMonth() === currentMonth && rfqDate.getFullYear() === currentYear;
    });

    console.log("This Month Projects:", this.thisMonthProjects);
  }
  
  onThisMonthClick() {
  this.getThisMonthProjects();
  this.matchedCustomerData = this.thisMonthProjects;

  this.updateTableRows();
}





  // Update table rows per page
  updateTableRows() {

    this.matchedCustomerData = this.matchedCustomerData.map(customer => {
      return {
        ...customer,  // Keep all other properties the same
        version_ids: Array.from({ length: customer.version_id }, (_, i) => i + 1) // Generate version_ids from 1 to version_id
      };
    });

    console.log('this.matchedCustomerData', this.matchedCustomerData)

    if (String(this.rowsPerPage) === 'All') {
      this.paginatedData = [...this.matchedCustomerData];
      console.log('paginatedData => ', this.paginatedData)
      // this.totalPages = 1;
    } else {
      // this.totalPages = Math.ceil(this.matchedCustomerData.length / this.rowsPerPage);
      this.currentPage = 1; // Reset to first page
      console.log('reset current page to 1 => ', this.currentPage)
      this.paginate();  
      // this.receiveData();
    }
  }
  updateCardCounts(): void {
    const today = new Date();

    this.openStatusCount = this.matchedCustomerData.filter(item => item.status === 'Open').length;

    this.overdueCount = this.matchedCustomerData.filter(item => {
      const expectedDate = new Date(item.expectedCompletionDate);
      return expectedDate < today && item.status === 'Open';
    }).length;

   
      this.thisMonthProjects = this.matchedCustomerData.filter(item => {
    const expectedDate = new Date(item.expectedCompletionDate);
    return expectedDate.getMonth() === today.getMonth() &&
           expectedDate.getFullYear() === today.getFullYear();
  });
  }


  paginate() {
    let state:any = history.state
    console.log('state => ', state)
    const rows = String(this.rowsPerPage) === 'All' ? this.matchedCustomerData.length : Number(this.rowsPerPage);
    console.log("currentPage  =>",this.currentPage)
    let startIndex = (this.currentPage - 1) * rows;
    let endIndex = startIndex + rows;
    if(state.hasOwnProperty('startIndex') && state.hasOwnProperty('endIndex') 
      && state.hasOwnProperty('currentPage') && state.hasOwnProperty('rowsPerPage')){
      startIndex = state.startIndex;
      endIndex = state.endIndex;
      this.currentPage = state.currentPage ?? 1;
      this.rowsPerPage = state.rowsPerPage ?? 10;
      history.replaceState({}, '');
    }
    this.paginatestartIndex = startIndex;
    this.paginateendIndex = endIndex;
    console.log("rows => ", rows ,"startIndex=>",startIndex,"endIndex=>",endIndex,"currentPage=>",this.currentPage)

    this.paginatedData = this.matchedCustomerData.slice(startIndex, endIndex);

    console.log('paginatedData', this.paginatedData)
  }

  nextPage() {
    console.log('nextPage => ', this.currentPage,  this.totalPages, this.currentPage < this.totalPages)
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.paginate();
    }
  }

  previousPage() {
    console.log('previousPage => ', this.currentPage)
    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginate();
    }
  }

  get totalPages(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.matchedCustomerData.length : Number(this.rowsPerPage);
    return Math.ceil(this.matchedCustomerData.length / rows);
  }

  get startIndex(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.matchedCustomerData.length : Number(this.rowsPerPage);
    return (this.currentPage - 1) * rows + 1;
  }

  get endIndex(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.matchedCustomerData.length : Number(this.rowsPerPage);
    return Math.min(this.currentPage * rows, this.matchedCustomerData.length);
  }

  trackByCustomer(index: number, customer: any): string {
    return `${customer.projectName}-${customer.customer_name}-${customer.version_id}-${customer.upload_status}`;
  }


  refreshPage() {
    this.isRefresh = true; // Show loader
    this.resetFields()
    this.resetFinalData()
    this.getAllcustomers();
    this.getAllOpenProjectData();
  }

  toggleSearch(index: number) {
    this.showSearch = true; // Show search row
    this.showSearchRow[index] = !this.showSearchRow[index]; // Toggle visibility for clicked column
  }


  filterData() {
    const hasSearch = this.searchValues.some(val => val && val.trim() !== '');

    if (hasSearch) {
      const filtered = this.finalCompareDataList.filter(item =>
        this.tableHeaders.every((col, i) => {
          const searchValue = this.searchValues[i]?.toLowerCase().trim();
          if (!searchValue) return true;
          const itemValue = item[col.key]?.toString().toLowerCase();
          return itemValue?.includes(searchValue);
        })
      );

      if (filtered.length > 0) {
        this.finalDataList = filtered;
      }
    } else {

      this.finalDataList = [...this.finalCompareDataList];
    }
  }


  getAllcustomers() {
    let cus = {
      "operation_type": "READALL"
    }
    this.masterService.all_customers(cus).subscribe((result: any) => {
     
      let message = result['message'];
      let status = result['status'];
      if (result) {
        
        this.allCustomerDetails = result;
        this.allCustomerData = result;
        console.log('allCustomerData', this.allCustomerData);

      } else {
        console.error('Error: Unable to retrieve project data');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }
    })
  }
loading = true; 
  getAllOpenProjectData() {
    let payloadData = {
     
      "action": "SELECT_PROJECTS",      
      "assigned_to_id": Number(this.userId)
    }
    this.loading = true;
    console.log('manage_projects payload => ', payloadData)
    this.masterService.manage_projects(payloadData).subscribe((result: any) => {
    console.log('manage_projects response => ', result)
       
      let message = result['message'];
      let status = result['status'];
      if (result) {
        setTimeout(() => {
          this.isRefresh = false;
           this.loading = false;

     
          let data = result['data'];
          console.log('allOpenProjectDetails', this.matchedCustomerData);

          
          this.matchedCustomerData = data;
         
          this.matchedCustomerData = data.map(customer => {
            const uploadStatus = customer.upload_status?.toLowerCase(); // normalize

            return {
              ...customer,
              version_ids: Array.from({ length: customer.version_id }, (_, i) => i + 1),
              
                progress:
      uploadStatus === 'new' || uploadStatus === 'inprogress'
        ? '0%'
        : customer.progress

            };
          });

      
          console.log('pagination data', this.paginatedData);

         
          this.allOpenProjectDetails = [...this.matchedCustomerData];

// Table initially shows full list
this.matchedCustomerData = [...this.allOpenProjectDetails];
          
          this.overdueCount = this.getOverdueItems(this.matchedCustomerData).length;


          this.openStatusCount = this.matchedCustomerData.filter(item =>
            item.status === 'Open' || item.status === 'In Progress'
          ).length;




          this.projectNameDetails = Array.from(
            new Set(this.matchedCustomerData.map(item => item.projectName))
          );
          console.log('projectNameDetails', this.projectNameDetails);
          this.updateTableRows();
          this.getThisMonthProjects();
        }, 1000);
     
      } else {
        setTimeout(() => {
          this.isRefresh = false;
        }, 1000)
        console.error('Error: Unable to retrieve project data');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    });
  }


  isLowerVersion(customer: any): boolean {
    const sameProjectCustomers = this.matchedCustomerData.filter(c => c.projectName === customer.projectName);
    const highestVersion = Math.max(...sameProjectCustomers.map(c => c.version_id));
    return customer.version_id < highestVersion;
  }

  fromDate: any;
  toDate: any;

  onDateSelection(date: any, type: string) {
    if (type === 'from') {
      this.fromDate = date;
    } else {
      this.toDate = date;
    }
  }

  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }


  onVersionChange(customer: any) {
   
    console.log('customer', customer)
    // Find the index of the current row based on the project_id
    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer.project_id);

    if (customerIndex !== -1) {
      // Update only the version_id for the specific row (matching the project_id)
      this.matchedCustomerData[customerIndex].version_id = Number(customer.version_id);

      // Log to check if the version_id is correctly updated
      console.log('Updated version_id for project:', this.matchedCustomerData[customerIndex].version_id);

      // Update the selected version id
      this.selectedVersionId = Number(customer.version_id);
      this.selectedRowProjectId = Number(customer.project_id);
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('project_id', String(this.selectedRowProjectId));


      let payloadData = {
        "action": "SELECT_PROJECTS",
        "assigned_to_id": Number(this.userId),
        "project_id": this.selectedRowProjectId,
        "version_id": this.selectedVersionId
      }
      this.masterService.manage_projects(payloadData).subscribe((result: any) => {
        let message = result['message'];
        let status = result['status'];
        if (result) {
          let data = result['data'];
          console.log('data', data)
          this.projectRowDetailsWithVersionId = data;
          console.log('projectRowDetailsWithVersionId', this.projectRowDetailsWithVersionId);
         

          // Find the object in result.data that matches project_id & version_id
          let matchingData = data.find(
            (dataItem: any) =>
              dataItem.project_id === this.selectedRowProjectId &&
              dataItem.version_id === this.selectedVersionId
          );

          if (matchingData) {
            let isUpdated = false;

            let sortedMatchingData = {
              ...matchingData,
              version_ids: [...matchingData.version_ids].sort((a, b) => a - b)
            };


            this.matchedCustomerData.forEach((item, index) => {
              if (item.project_id === this.selectedRowProjectId && item.version_id === this.selectedVersionId) {
                isUpdated = true;

                this.matchedCustomerData[index] = { ...item, ...sortedMatchingData };
              }
            });

            console.log('this.matchedCustomerData after update:', this.matchedCustomerData);

            if (!isUpdated) {
              this.notify.danger('Data not found');
            } else {
              this.projectRowDetailsWithVersionId = matchingData;

              this.matchedCustomerData = [...this.matchedCustomerData];
              this.paginatedData = [...this.matchedCustomerData];
              console.log('paginatedData => ', this.paginatedData)
            }
          } else {
            this.notify.danger('Data not found in response');
          }
        
        } else {
          // Handle error if status is not true
          console.error('Error: Unable to retrieve project data');
          this.notify.danger('There was an issue retrieving the project data. Please try again.');
        }

      });

    }
  }

 

  // Start adding a new version (only once per row)
  startAddingNewVersion(customer: any) {
    if (!customer.isAddingNewVersion) {
      const lastVersion = customer.version_ids.length > 0 ? Math.max(...customer.version_ids) : 0;
      customer.newVersion = lastVersion + 1; // Suggest the next version number
      customer.isAddingNewVersion = true;
    }
  }


  
saveNewVersion(customer: any) {
  if (customer.newVersion) {
    // Check previous version status
    const previousVersion = customer.version_ids.find(version => version === customer.newVersion - 1);
  
    const previousVersionData = this.paginatedData.find(
      (item) =>
        item.project_id === customer.project_id &&
        item.projectName === customer.projectName &&
        item.version_id === previousVersion
    );
    console.log("paginatedData previousVersionData => ",previousVersionData, this.paginatedData)

    if (previousVersionData) {
      const prevStatus = previousVersionData.upload_status?.toLowerCase();
      if (prevStatus === 'new' || prevStatus === 'error') {
        this.notify.danger(`Cannot add new version. Previous version (${previousVersion}) is in "${previousVersionData.upload_status}" state.`);
        return;
      }
    } else {
      this.notify.danger("Previous version not found.");
      return;
    }

    // Retrieve version 1 data to get default values
    const version1Data = this.paginatedData.find(
      (item) =>
        item.project_id === customer.project_id &&
        item.projectName === customer.projectName &&
        item.version_id === 1
    );

    console.log("paginatedData version1Data => ",version1Data, this.paginatedData)

    // Assign values: use current if defined, else fallback to version 1
    const q1Val = customer.q1 !== undefined ? customer.q1 : version1Data?.q1;
    const q2Val = customer.q2 !== undefined ? customer.q2 : version1Data?.q2;
    const q3Val = customer.q3 !== undefined ? customer.q3 : version1Data?.q3;
    const dutyPercentage = customer.duty_percentage !== undefined 
      ? customer.duty_percentage 
      : (version1Data?.duty_percentage || 0);

    // Prepare payload
    const payload = {
      action: "INSERT_NEW_VERSION",
      project_id: customer.project_id,
      projectName: customer.projectName,
      rfqDate: customer.rfqDate,
      expectedCompletionDate: customer.expectedCompletionDate,
      targetLeadTime: customer.targetLeadTime,
      created_by_id: customer.created_by_id,
      created_date: customer.created_date,
      assigned_to_id: customer.assigned_to_id,
      assigned_date: customer.assigned_date,
      customer_id: customer.customer_id,
      ageing: customer.ageing,
      progress: customer.progress,
      status: customer.status,
      currentstage: customer.currentstage,
      activestatus: customer.activestatus,
      version_id: customer.newVersion,
      q1: q1Val,
      q2: q2Val,
      q3: q3Val,
      duty_percentage: dutyPercentage
    };

    // Update customer object
    customer.version_ids.push(customer.newVersion);
    customer.version_id = customer.newVersion;
   console.log("Payload being sent:", payload);
    // API call
    this.masterService.manage_projects(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result: any) => {
          if (result.status === 'success') {
            this.notify.success('Version updated successfully!');
            this.getAllOpenProjectData();
          } else {
            this.notify.danger('Error updating version. Please try again.');
          }
        },
        (error) => {
          console.error('Error:', error);
          this.notify.danger('Something went wrong. Please check your connection.');
        }
      );
  }
}



  cancelNewVersion(customer: any) {
    customer.isAddingNewVersion = false;
    customer.newVersion = null;
  }

  onRowSelect(customer: any) {
   
    let role:any = sessionStorage.getItem('role');
    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer.project_id);
    if (customerIndex !== -1) {
      this.matchedCustomerData[customerIndex].version_id = Number(customer.version_id);
      console.log(this.matchedCustomerData[customerIndex].version_id);
      this.selectedVersionId = Number(customer.version_id);
      console.log(customer, 'customer')
      this.selectedProjectId = Number(customer.project_id);
      this.selectedProjectName = String(customer.projectName);
      sessionStorage.setItem('project_id', this.selectedProjectId);
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      this.menuService.setRole(role);
      if (this.selectedVersionId) {
        sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer));
        this.router.navigate(['/project-view'], {

          state: { customerInfo: customer, 
            startIndex:this.paginatestartIndex,
            endIndex:this.paginateendIndex,
            currentPage:this.currentPage,
            rowsPerPage:this.rowsPerPage, 
            matchedData: this.matchedCustomerData }

        });
      } else {
        this.notify.info('Please select version_id.')
      }
    }
  }
 
  onSelectProject() {

    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';

    this.matchedCustomerData = this.matchedCustomerData.filter(customer => customer.status === 'Open');
    this.matchedCustomerData = this.allOpenProjectDetails
      .filter(project => project.projectName === this.selectedProjectName)
      .map(project => ({
        serialNumber: project.serialNumber,
        rfqDate: project.rfqDate,
        expectedCompletionDate: project.expectedCompletionDate,
        project_id: project.project_id,
        projectName: project.projectName,
        targetLeadTime: project.targetLeadTime,
        created_by_id: project.created_by_id,
        created_date: project.created_date,
        assigned_to_id: project.assigned_to_id,
        assigned_date: project.assigned_date,
        customer_id: project.customer_id,
        ageing: project.ageing,
        progress: project.progress,
        status: project.status,
        upload_status: project.upload_status,
        version_id: project.version_id,
        currentstage: project.currentstage,
        activestatus: project.activestatus,
        customer_name: project.customer_name
      }));
    console.log('Matched Customer Data:', this.matchedCustomerData);
    this.updateTableRows();
    this.updateCardCounts();
    
  }

  onSelectCustomer() {
    
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    // Filter rows where the customer_name matches the selectedCustomerName
    this.matchedCustomerData = this.matchedCustomerData.filter(customer => customer.status === 'Open');
    this.matchedCustomerData = this.allOpenProjectDetails
      .filter(project => project.customer_name === this.selectedCustomerName)
      .map(project => ({
        serialNumber: project.serialNumber,
        rfqDate: project.rfqDate,
        expectedCompletionDate: project.expectedCompletionDate,
        project_id: project.project_id,
        projectName: project.projectName,
        targetLeadTime: project.targetLeadTime,
        created_by_id: project.created_by_id,
        created_date: project.created_date,
        assigned_to_id: project.assigned_to_id,
        assigned_date: project.assigned_date,
        customer_id: project.customer_id,
        ageing: project.ageing,
        progress: project.progress,
        status: project.status,
        version_id: project.version_id,
        upload_status: project.upload_status,
        currentstage: project.currentstage,
        activestatus: project.activestatus,
        customer_name: project.customer_name
      }));
    // Check the results in the debugger console
    console.log('Matched Customer Data:', this.matchedCustomerData);
    this.updateTableRows();
    this.applyFilters();
    this.updateCardCounts();
  }


  onOpenClickedProject(status: string) {
  console.log('openStatusCount', this.openStatusCount, status);

  this.matchedCustomerData = this.allOpenProjectDetails.filter(
    customer => customer.status === status
  );

  this.updateTableRows();
}

 
  onOverdueClick() {
  const overdueProjects = this.getOverdueItems(this.allOpenProjectDetails);

  this.matchedCustomerData = overdueProjects;
  this.overdueCount = overdueProjects.length;

  this.updateTableRows();
}


  getOverdueItems(data: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter(item => {
      const expectedDate = new Date(item.expectedCompletionDate);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && item.status === 'Open';
    });
  }



  onSelectEnginner() {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedExpetedCompletionDate = '';
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.assignedTo === this.selectedEngineer)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
    this.updateTableRows();
  }

  onSelectStage(eve: any) {
    // this.matchedCustomerData = this.allCustomerData
    this.selectedProjectName = '';
    // this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    let selectedStage = eve.target.value
    console.log('selectedStage', selectedStage);
    this.matchedCustomerData = this.matchedCustomerData.filter(customer => customer.status === 'Open');
    this.matchedCustomerData = this.allOpenProjectDetails
      .filter(project => project.currentstage === this.selectedCurrentStage)
      .map(project => ({
     
        serialNumber: project.serialNumber,
        rfqDate: project.rfqDate,
        expectedCompletionDate: project.expectedCompletionDate,
        project_id: project.project_id,
        projectName: project.projectName,
        targetLeadTime: project.targetLeadTime,
        created_by_id: project.created_by_id,
        created_date: project.created_date,
        assigned_to_id: project.assigned_to_id,
        assigned_date: project.assigned_date,
        customer_id: project.customer_id,
        ageing: project.ageing,
        progress: project.progress,
        status: project.status,
        version_id: project.version_id,
        upload_status: project.upload_status,
        currentstage: project.currentstage,
        activestatus: project.activestatus,
        customer_name: project.customer_name
      }));
    this.updateTableRows();
    this.selectedCurrentStage = eve.target.value;
    console.log('Selected Stage:', this.selectedCurrentStage);
    this.applyFilters();
    this.updateCardCounts();

  }
  applyFilters() {
    this.matchedCustomerData = this.allOpenProjectDetails.filter(project => {
      const matchesProject = this.selectedProjectName ? project.projectName === this.selectedProjectName : true;
      const matchesCustomer = this.selectedCustomerName ? project.customer_name === this.selectedCustomerName : true;
      const matchesStage = this.selectedCurrentStage ? project.currentstage === this.selectedCurrentStage : true;
      
      let matchesECD = true;
      if (this.fromExpectedCompletionDate && this.toExpectedCompletionDate) {
        const expectedDate = new Date(project.expectedCompletionDate);
        const fromECD = new Date(this.fromExpectedCompletionDate);
        const toECD = new Date(this.toExpectedCompletionDate);
        matchesECD = expectedDate >= fromECD && expectedDate <= toECD;
      }

      // RFQ Date Range
      let matchesRFQ = true;
      if (this.fromRfqDate && this.toRfqDate) {
        const rfqDate = new Date(project.rfqDate);
        const fromRFQ = new Date(this.fromRfqDate);
        const toRFQ = new Date(this.toRfqDate);
        matchesRFQ = rfqDate >= fromRFQ && rfqDate <= toRFQ;
      }

      return matchesProject && matchesCustomer && matchesStage && matchesECD && matchesRFQ;
    }).map(project => ({
      serialNumber: project.serialNumber,
      rfqDate: project.rfqDate,
      expectedCompletionDate: project.expectedCompletionDate,
      project_id: project.project_id,
      projectName: project.projectName,
      targetLeadTime: project.targetLeadTime,
      created_by_id: project.created_by_id,
      created_date: project.created_date,
      assigned_to_id: project.assigned_to_id,
      assigned_date: project.assigned_date,
      customer_id: project.customer_id,
      ageing: project.ageing,
      progress: project.progress,
      status: project.status,
      upload_status: project.upload_status,
      version_id: project.version_id,
      currentstage: project.currentstage,
      activestatus: project.activestatus,
      customer_name: project.customer_name
    }));

    this.updateTableRows();
  }



  // Open ECD Modal
  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
  }
  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
  }
  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
  }




  onSelectCompletionDate() {
  
    this.selectedRfqDate = '';
    this.matchedCustomerData = this.allOpenProjectDetails.filter(cus => {
      const expectedCompletionDate:any = new Date(cus.expectedCompletionDate);
      const fromDate:any = new Date(this.fromExpectedCompletionDate);
      const toDate:any = new Date(this.toExpectedCompletionDate);

      // Check if the customer's expectedCompletionDate is within the selected range
      return expectedCompletionDate >= fromDate && expectedCompletionDate <= toDate && cus.status === 'Open';
    }).map(cus => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      upload_status: cus.upload_status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    this.updateTableRows();
    this.applyFilters();
    this.updateCardCounts();
  }
 
  onDateRangeChange() {
    
    this.selectedExpetedCompletionDate = '';
   
    console.log('Selected To RFQ Date:', this.toRfqDate);
    this.matchedCustomerData = this.allOpenProjectDetails.filter(cus => {
      const rfqDate:any = new Date(cus.rfqDate);  // Customer RFQ date
      const fromDate:any = new Date(this.fromRfqDate); // Selected "From" date
      const toDate:any = new Date(this.toRfqDate);  // Selected "To" date

      // Check if the customer's RFQ date is within the range
      return rfqDate >= fromDate && rfqDate <= toDate && cus.status === 'Open';
    }).map(cus => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      upload_status: cus.upload_status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    this.updateTableRows();
    this.applyFilters();
    this.updateCardCounts();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.customerName === this.selectedCustomerName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        upload_status: cus.upload_status,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
  }

  activeTab: number = 1; // Track the active tab

  // Sample data for each table
  tableData1 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' },
    { column1: 'Row 2, Col 1', column2: 'Row 2, Col 2', column3: 'Row 2, Col 3' }
  ];
  tableData2 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData3 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData4 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    this.activeTab = tabNumber;
  }

  back() {
    this.router.navigate(['/master/additional-charges/table']);
  }

 

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal) {
    this.modalRef = this.modalService.open(customerModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  resetFields() {
    this.isRefresh = true; // Show loader
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.resetFinalData();
    this.getAllcustomers();
    this.getAllOpenProjectData();
    this.updateTableRows();

  }
  openProjectModel(projectModal) {
    this.modalRef = this.modalService.open(projectModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  onLandinCost(landinCostModal) {
    this.modalRef = this.modalService.open(landinCostModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

 
  closeModal() {
   
    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }

  save() {
   
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }
  saveCustomer() {

    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  showQn4: boolean = false;
  showQn5: boolean = false;

  onQn1Change(answer: string) {
    if (answer === 'yes') {
      this.showQn2 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn2Change(answer: string) {
    if (answer === 'yes') {
      this.showQn3 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn3Change(answer: string) {
    this.showQn4 = true;
  }

  onQn4Change(answer: string) {
    if (answer === 'no') {
      this.showQn5 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;
    this.showQn4 = false;
    this.showQn5 = false;
  }

  saveLandingCost() {
   
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }

  dragNdropIncor(event: any) {
 
    this.incorUploadFiles = [];
    this.selectedIncorFile = event.target.files;
    for (var i = 0; i < this.selectedIncorFile.length; i++) {
      if (this.selectedIncorFile[i]) {
        const file = this.selectedIncorFile[i];
        var reader = new FileReader();
        reader.onload = (event: any) => {
          var str = event.target.result;          
          var name = file.name.split('.').slice(0, -1).join('.');
          var type = file.type;
          var size = file.size;
          var exe = file.name.split('.').pop();
          
          var splitField = str
            .replace('data:', '')
            .replace(/^.+,/, '');

          let allFiles = {
            fileName: name,
            fileExtension: exe,
                   
            fileByte: splitField
          }
          this.incorUploadFiles.push(allFiles);
          let form:any  = this.form
        
          let temp = this.form.value.source_file_name;
          if (temp == "") {
            form.get('source_file_name').patchValue(file.name);
          } else {
            form.get('source_file_name').patchValue(temp + ', ' + file.name);
          }
        }
        reader.readAsDataURL(this.selectedIncorFile[i]);
      }
    }
    console.log('uploaded Files', this.incorUploadFiles)
  }


  uploadSourcingList(uploadFileModal, engineer) {
   
    this.selectedProjectId = engineer.project_id;
  
    this.selectedVersionId = engineer.version_id;
    if (!this.selectedVersionId) {
     
      this.notify.info('Please select version_id.')
      return
    }
    this.modalRef = this.modalService.open(uploadFileModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  

  
  // This function is triggered when a file is selected
  uploadSourcingListFiles(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const wsname2: string = wb.SheetNames[1];
      const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];

      this.data = XLSX.utils.sheet_to_json(ws);
      let customObjFromExcel = XLSX.utils.sheet_to_json(ws2);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (var j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }
      this.uploadedHeaders = Object.keys(this.data[0]).filter(h => h !== '__rowNum__');
    this.fieldMapping = {};
    this.uploadedHeaders.forEach(header => {
      this.fieldMapping[header] = null;
    });
     this.validateHeaders();
      this.sourceListData = [];
      let form :any = this.form
      // Set the file name in the variable
      this.sourcingListFileName = target.files[0].name;
      console.log(this.sourcingListFileName); // Display file name in console

      form.get('sourcingListFileName').setValue(this.sourcingListFileName); // Optionally update form control

      console.log(this.data);
      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          SlNo: this.data[i]['Sl no'],
          customerPartNumber: String(this.data[i]['Customer Part No.']).trim(),
          internalPartNo: String(this.data[i]['Internal Part No.']).trim(),
          description: String(this.data[i]['Description']).trim(),
          // specification: String(this.data[i]['Specification']).trim(),
          specification: String(this.data[i]['Specification']).trim().replace(/\s+/g, ''),
          commodity: String(this.data[i]['Commodity']).trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)']).trim(),
          uom: String(this.data[i]['UOM']).trim(),
          projectQty: Number(this.data[i]['Project qty']),
          iSourcing: String(this.data[i]['I Sourcing']).trim(),
        };
        this.sourceListData.push(obj);
        if (this.avdData.length === 0) {
          this.finalDataList = this.sourceListData;
        }
        console.log('sourceListData', this.sourceListData);

      }
    };
   
  }

  

validateHeaders() {
  this.headerErrorMessage = '';
  this.isHeaderMappingRequired = false;

  const normalize = (str: string) => str?.toLowerCase().replace(/\s+/g, '').trim();

  // Define optional headers here
  const optionalHeaders = ['I Sourcing'];

  const expectedLabels = this.expectedFields
    .filter(f => !optionalHeaders.includes(f.label)) // remove optional from required list
    .map(f => normalize(f.label));

  const uploadedLabels = this.uploadedHeaders.map(h => normalize(h));

  // Find missing headers (excluding optional ones)
  const missing = this.expectedFields
    .filter(f => !optionalHeaders.includes(f.label)) // skip optional in check
    .filter(f => !uploadedLabels.includes(normalize(f.label)))
    .map(f => f.label);

  if (missing.length > 0) {
    this.headerErrorMessage = 'Missing headers: ' + missing.join(', ');
    this.isHeaderMappingRequired = true;
  } else {
    this.isHeaderMappingRequired = false;
  }

  // Auto-map (including optional if present)
  this.reverseFieldMapping = {};
  this.tableHeaders.forEach(header => {
    const expectedField = this.expectedFields.find(f => f.key === header.key);
    if (expectedField) {
      const matchedHeader = this.uploadedHeaders.find(
        h => normalize(h) === normalize(expectedField.label)
      );
      this.reverseFieldMapping[header.key] = matchedHeader || null;
    }
  });
}



  clearSourcingListFiles() {
    // Reset local variables and form
    this.sourcingListFileName = '';
    this.form.get('sourcingListFileName')?.setValue('');
    this.sourceListData = [];
    this.finalDataList = [];

    // Check if the uploadInput is valid before resetting its value
    const uploadInput = document.querySelector<HTMLInputElement>('.file-input');
    if (uploadInput) {
      uploadInput.value = ''; // Clear the input field
    } else {
      console.warn('File input is not defined. Skipping clearing input value.');
    }
  }


  uploadAvdFiles(event: any) {
    this.finalDataList = [];
    this.avdData = [];

    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);

    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const wsname2: string = wb.SheetNames[1];
      const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];

      this.data = XLSX.utils.sheet_to_json(ws);
      let customObjFromExcel = XLSX.utils.sheet_to_json(ws2);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (let j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }

      
      // Set the file name in the variable
      this.alternatePartFileName = target.files[0].name;
      console.log(this.alternatePartFileName); // Display file name in console
      let form:any = this.form
      form.get('alternatePartFileName').setValue(this.alternatePartFileName); // Optionally update form control
     

      // Process the file data and populate avdData
      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          internalPartNo: String(this.data[i]['Internal Part No.']).trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)']).trim(),          
          specification: String(this.data[i]['Specification']).trim().replace(/\s+/g, ''),
        };
        this.avdData.push(obj);
        console.log('avdData', this.avdData);
      }
    };
  }


  finalXlsx: any = [
    ['Material Number', 'Material Desc.', 'Mfr. Code', 'Manufacturer', 'Mfr.Ref']
  ]
  isN(s) {
    return (/^-?\d+(\.\d+)?$/.test(s)) && s.length < 4;
  }
  mergeByXPosition(data) {
    const grouped = new Map();

    for (const obj of data) {
      const x = obj.transform[obj.transform.length - 2]; // get X value

      if (!grouped.has(x)) {
        grouped.set(x, []);
      }

      grouped.get(x).push(obj);
    }

    const result:any = [];

    for (const [x, group] of grouped.entries()) {
      if (group.length === 1) {
        result.push(group[0]); // keep single item as is
      } else {
        // Merge all objects with same X
        const merged = {
          ...group[0], // copy first object as base
          str: group.map(o => o.str).join(' '), // concatenate all str values
          hasEOL: group[group.length - 1].hasEOL // preserve EOL from last
        };
        result.push(merged);
      }
    }

    return result;
  }
  xlsxtable: any[] = [];
  async uploadPdfAndConvert(event: any) {
    const file: File = event.target.files[0];

    if (!file || !file.name.endsWith('.pdf')) {
      alert('Please upload a PDF file.');
      return;
    }

    this.alternatePartFileName = file.name;

    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

      const tableData: string[][] = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        let eachlastrow = textContent.items.slice(textContent.items.length - 11), lastrow = {}
        console.log('textContent', textContent)
        let fpdf:any = [], tele:any = []

        let trow = eachlastrow.filter((e: any) => e.str !== " " && e.str !== "" && e.str !== ":");

        let xtrow = this.mergeByXPosition(trow)
          .map((obj: any) => obj.str)
          .filter((str: string, index: number) => {
            
            if (index === 0) {
              return str.length >= 12;
            }

            if (/^-?\d+(\.\d+)?$/.test(str)) {
              return str.length >= 4;
            }
            return true; // keep all others
          });



        textContent.items.forEach((e: any, i) => {
          console.log(e)
          if (e.str === " " || e.str === "" || e.str === ":") { }
          else {

            if ((this.isN(e.str))) {

              fpdf.push(this.mergeByXPosition(tele))
              tele = []
            }
            else {
              tele.push(e)
            }
          }
          if (i === textContent.items.length - 1) {
            console.log("fpdf => ", fpdf)

          
            let pro = this.normalizeRows(fpdf.slice(1))
            pro.forEach((fe, fi) => {
              this.finalXlsx.push(fe.map((obj: any) => obj.str))
              
              console.log(pro.length - 1, "=>>", fi)
              if (pro.length - 1 === fi) {
                this.finalXlsx.push(xtrow)
                console.log(fi, 'completed Successfuly', this.finalXlsx, fpdf)

              }
            })

          }
        })

      }


      setTimeout(() => {
        
      }, 1000);

      this.avdData = [];

      for (let i = 1; i < this.finalXlsx.length; i++) {
        const row = this.finalXlsx[i];

        const obj = {
          internalPartNo: String(row[0]).trim(),        // Material Number
          manufacturer: String(row[3]).trim(),          // Manufacturer
          specification: String(row[2]).trim().replace(/\s+/g, '') // Mfr. Code as "specification"
        };

        this.avdData.push(obj);
      }

      this.form.get('alternatePartFileName')?.setValue(this.alternatePartFileName);
      console.log("Extracted AVD Data from PDF:", this.avdData);

    } catch (error) {
      console.error("Error processing the PDF file:", error);
    }
  }

  normalizeRows(input: string[][]): string[][] {
    const result: string[][] = [];

    let i = 0;
    while (i < input.length) {
      const current = input[i];

      // Handle [2, 3] merge: next row is length 3, current is length 2
      if (current.length === 2 && input[i + 1] && input[i + 1].length === 3) {
        const next = input[i + 1];
        const merged = [...current, ...next]; // 3 first, then 2
        result.push(merged);
        i += 2; // skip next
      } else if (current.length === 5) {
        result.push(current);
        i++;
      } else {
        // Optional: pad to 5 if needed
        const padded = [...current];
        while (padded.length < 5) padded.push('');
        result.push(padded);
        i++;
      }
    }
    return result;
  }

  exportToExcel(data: any[][]) {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ExtractedData');
    XLSX.writeFile(wb, 'converted-from-pdf.xlsx');
  }
  xmlFile() {
    console.log("this.finalXlsx => ", this.finalXlsx)
    const dummyData: any[][] = [
      ['ID', 'Name', 'Description', 'Quantity', 'Price'],
      [1, 'Item A', 'Description of Item A', 10, '$25.00'],
      [2, 'Item B', 'Description of Item B', 5, '$15.00'],
      [3, 'Item C', 'Long description\nacross multiple lines', 20, '$10.00'],
      [4, 'Item D', 'Final item', 8, '$30.00']
    ];

  }


isLoading = false; // Add this flag in your component

handleFileUpload(event: Event): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];

  if (!file) return;

  this.isLoading = true; // start loading
  this.alternatePartFileName = file.name;
  this.form.get('alternatePartFileName')?.setValue(this.alternatePartFileName);

  const fileType = file.name.toLowerCase();

  if (fileType.endsWith('.pdf')) {

    this.uploadPdfAndConvert({ target: { files: [file] } })
      .then(() => {
        this.isLoading = false; // stop loading after PDF upload completes
      })
      .catch(() => {
        this.isLoading = false; // stop loading on error as well
      });
  } else if (fileType.endsWith('.xlsx')) {
    
    this.uploadAvdFiles({ target: { files: [file] } });
    this.isLoading = false; // stop loading after initiating Excel upload
  } else {
    alert('Unsupported file type. Please upload a PDF or Excel (.xlsx) file.');
    this.isLoading = false; // reset loading for unsupported file
  }
}




  clearAvdFiles() {
    // Reset local variables and form values
    this.alternatePartFileName = '';
    this.form.get('alternatePartFileName')?.setValue('');
    this.avdData = [];

    // Ensure file input field is reset properly
    if (this.uploadAvdInputRef?.nativeElement) {
      this.uploadAvdInputRef.nativeElement.value = ''; // Clear the file input field
    } else {
      console.warn('File input is not defined. Skipping clearing input value.');
    }
  }


  finalData() {
  this.isLoading = true; // start loading

  if (this.sourceListData.length === 0) {
    this.notify.info('Please upload sourcing list');
    this.clearAvdFiles();
    this.clearSourcingListFiles();
    this.closeModal();
    this.isLoading = false; // stop loading since no processing needed
  } else {
    this.finalDataList = [];
    this.matchedCustomerData = [];
    this.fetchAllManufacturerMatches();

    if (this.avdData.length > 0) {
      for (const avdItem of this.avdData) {
        const matchingSourceItems = this.sourceListData.filter(
          (sourceItem) => String(sourceItem.internalPartNo).trim() === String(avdItem.internalPartNo).trim()
        );

        if (matchingSourceItems.length > 0) {
          for (const sourceItem of matchingSourceItems) {
            const combinedRow = {
              ...avdItem,
              customerPartNumber: sourceItem.customerPartNumber,
              description: sourceItem.description,
              commodity: sourceItem.commodity,
              uom: sourceItem.uom,
              projectQty: parseFloat(sourceItem.projectQty).toFixed(2),
              iSourcing: sourceItem.iSourcing,
            };
            this.finalDataList.push(combinedRow);
          }
        }
      }
    }

    if (this.avdData.length === 0 || !this.avdData) {
      this.notify.warning('Data processed without AVD file');
      this.finalDataList = [...this.sourceListData];
    } else {
      for (const sourceItem of this.sourceListData) {
        const matchingAvdItem = this.avdData.find(
          (avdItem) => String(avdItem.internalPartNo).trim() === String(sourceItem.internalPartNo).trim()
        );

        if (!matchingAvdItem) {
          const combinedRow = {
            ...sourceItem,
            customerPartNumber: sourceItem.customerPartNumber,
            description: sourceItem.description,
            commodity: sourceItem.commodity,
            uom: sourceItem.uom,
            projectQty: parseFloat(sourceItem.projectQty).toFixed(2),
            iSourcing: sourceItem.iSourcing,
          };
          this.finalDataList.push(combinedRow);
        }
      }
    }

    this.processFinalData();
    console.log('Before Filtered Final Data List:', this.finalDataList);
    this.isLoading = false; // stop loading after processing is done
  }
}




  processFinalData() {
    // debugger
    const uniqueDataMap = new Map<string, any>();

    for (const data of this.finalDataList) {
      // Normalize key without ignoring special characters
      const normalizeString = (value: string | number): string => {
        if (typeof value !== 'string') return String(value).trim();
        return value.trim(); // Keep all characters, including special characters
      };

      // Create a key with special characters intact
      const key = `${normalizeString(data.internalPartNo)}::${normalizeString(data.manufacturer)}::${normalizeString(data.specification)}::${Number(data.projectQty)}`;

      if (!uniqueDataMap.has(key)) {
        uniqueDataMap.set(key, data); // Add unique rows
      }
    }

    // Convert the map back to a list
    this.finalDataList = Array.from(uniqueDataMap.values());

    console.log('Filtered Final Data List:', this.finalDataList);

    // Notify the user if duplicates were removed
    const originalLength = this.sourceListData.length + this.avdData.length;
    if (this.finalDataList.length < originalLength) {
      console.log('Duplicate rows have been removed.');
    }

    setTimeout(() => {
      this.sourceListData = [];
      this.avdData = [];
      this.closeModal();
    }, 100);
    this.finalCompareDataList = this.finalDataList;
  }

  closeUploadModal() {
    this.clearAvdFiles();
    this.clearSourcingListFiles();
     this.headerErrorMessage = '';
 
    this.closeModal();
  }

  onClickSmartSync() {
    this.router.navigate(['/smart-sync'])
  }

  uploadFinalData() {
    if (!this.selectedVersionId) {
      this.notify.info('Please select version_id.');
      return;
    }

    this.isUploading = true; // Show loader   

    console.log(this.finalDataList);
    sessionStorage.setItem('project_id', this.selectedProjectId);
    sessionStorage.setItem('version_id', String(this.selectedVersionId));

    const groupedData = new Map();
    this.finalDataList.forEach(part => {
      const internalPartNo = String(part.internalPartNo) || "";
      if (!groupedData.has(internalPartNo)) {
        groupedData.set(internalPartNo, {
          part_header: {
            internalPartNo: internalPartNo,
            customerPartNumber: String(part.customerPartNumber) || "",          
            description: (String(part.description).replace(/"/g, '').replace(/\\/g, '/')) || "",           
            commodity: (String(part.commodity).replace(/"/g, '').replace(/\\/g, '/')) || "",
            uom: String(part.uom) || "",
            projectQty: Number(part.projectQty) > 0 ? Number(part.projectQty) : 0,
            iSourcing: part.iSourcing == "Yes" ? "Yes" : "No",
            stockAvailability: Number(part.stockAvailability) >= 0 ? Number(part.stockAvailability) : 0,
            leadTime: Number(part.leadTime) ? Number(part.leadTime) : 0,
            minimumPrice: Number(part.minimumPrice) >= 0 ? Number(part.minimumPrice) : 0,
            authorisedSuppliers: Number(part.authorisedSuppliers) >= 0 ? Number(part.authorisedSuppliers) : 0,
            suppliers: part.suppliers && part.suppliers.length > 0
              ? part.suppliers.map(s => s.supplierName)
              : [],
            eau: Number(part.eau) >= 0 ? Number(part.eau) : 0,
          },
          Parts: []
        });
      }

    
      const originalManufacturer = part.manufacturer;
      const selectedManufacturer = this.manufacturerOverrideMap[originalManufacturer] || originalManufacturer;

      
      groupedData.get(internalPartNo).Parts.push({
  specification: (String(part.specification).replace(/"/g, '').replace(/\\/g, '/')) || "",
  manufacturer: selectedManufacturer
});


    });

    const finalPayload = {
      project_id: this.selectedProjectId,
      version_id: this.selectedVersionId,      
        sourcing_type: this.dataPreference.length > 0 ? this.dataPreference : null,
      data: Array.from(groupedData.values())
    };

    console.log('finalPayload', finalPayload);

    this.masterService.finalCompareData(finalPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.isUploading = false;
          if (res) {
            this.notify.success('Data uploaded successfully...');
            this.form.reset();
            this.resetFinalData();
            this.refreshSubscription$.next();

            interval(30000)
              .pipe(take(5), takeUntil(this.refreshSubscription$), takeUntil(this.destroy$))
              .subscribe(() => {
                this.getAllOpenProjectData();
                this.notify.success('Data refreshed...!!!');
              });

          } else {
            this.notify.danger('Unexpected response received. Please try again.');
          }
        },
        error: (err) => {
          this.isUploading = false;
          console.error('An error occurred:', err);
          let errorMessage = 'An error occurred while uploading data. Please try again.';
          if (err?.message) {
            errorMessage = `Error: ${err.message}`;
          } else if (err?.error?.message) {
            errorMessage = `Error: ${err.error.message}`;
          }
          this.notify.danger(errorMessage);
        }
      });
  }

  selectCriteria(criteriaModal) {
    // Logic for selecting criteria goes here
    console.log('Criteria selected');
    this.isUploadEnabled = true; // Enable the Upload button after criteria selection.
    this.modalRef = this.modalService.open(criteriaModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  resetFinalData() {
   
    this.isUploadEnabled = false;
    this.sourcingListFileName = '';
    let form:any = this.form
    form.get('sourcingListFileName').setValue('');    
    this.alternatePartFileName = '';
    form.get('alternatePartFileName').setValue('');    
    this.sourceListData = [];
    this.avdData = [];
    this.finalDataList = [];
    this.selectedManufacturerMap = {};
    this.isDropdownVisible = {};
    this.buttonColorMap = {};
    this.buttonBorderStyle = {};
    this.allManufacturerDetailsMap = {};
    this.manufacturerOverrideMap = {};
    this.getAllcustomers();
    this.getAllOpenProjectData();
    this.updateTableRows();
    this.clearAllManufacturerDetails();
     this.headerErrorMessage = '';
  }

  sourcingData(): void {
    this.exportService.exportToExcel(this.sourcingDummyData, 'Source_data.xlsx', 'Source_data');
  }
  alternateData(): void {
    this.exportService.exportToExcel(this.avdDummyData, 'Avd_data.xlsx', 'Avd_DataSheet');
  }
  exportData(): void {
    this.exportService.exportToExcel(this.finalDataList, 'Final_data.xlsx', 'FinalDataSheet');
  }

  // Cleanup subscriptions when component is destroyed
  ngOnDestroy(): void {
    this.destroy$.next(); // Stop all subscriptions
    this.destroy$.complete();
    this.refreshSubscription$.next(); // Stop refresh interval
    this.refreshSubscription$.complete();
  }

  fetchAllManufacturerMatches() {
    this.sourceListData.forEach((item: any) => {
      const payloadData = {
        name: String(item.manufacturer).trim()
      };
      this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
        if (result) {
          this.buttonColorMap[item.manufacturer] = result.exact_match === 1 ? 'btn-mfgs' : 'btn-mfg';
          this.allManufacturerDetailsMap[item.customerPartNumber] = result.matches; // Use customerPartNumber as key
          this.showDropdownMap[item.customerPartNumber] = false;
        } else {
          console.error('Error: Unable to retrieve manufacturer data');
          this.buttonColorMap[item.manufacturer] = 'btn-light';
        }
      });
    });
  }


  checkManufacturerMatch(item: any, index: number) {
  const uniqueKey = index;
  const payloadData = {
    name: String(item.manufacturer).trim()
  };

  this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
    if (result) {
      // Add original manufacturer first, then matches
      const matches = result.matches || [];
      if (!matches.includes(item.manufacturer)) {
        matches.unshift(item.manufacturer);  // Keep original manufacturer at top
      }

      this.allManufacturerDetailsMap[uniqueKey] = matches;

      // Don't auto-select here, let user pick manually
      if (!this.selectedManufacturerMap[uniqueKey]) {
        this.selectedManufacturerMap[uniqueKey] = item.manufacturer;
      }

      console.log('Manufacturer data loaded for:', uniqueKey, this.allManufacturerDetailsMap[uniqueKey]);
    } else {
      console.error('Error: Unable to retrieve manufacturer data');
    }
  });
}



  toggleDropdownVisibility(item: any, index: number) {
    const uniqueKey = index;
    this.isDropdownVisible[uniqueKey] = !this.isDropdownVisible[uniqueKey];

    if (this.isDropdownVisible[uniqueKey] && !this.allManufacturerDetailsMap[uniqueKey]) {
      this.checkManufacturerMatch(item, index);
      return;
    }

    if (this.isDropdownVisible[uniqueKey] && this.allManufacturerDetailsMap[uniqueKey]?.length > 0) {
      if (!this.selectedManufacturerMap[uniqueKey]) {
        const defaultValue = this.allManufacturerDetailsMap[uniqueKey][0];
        this.selectedManufacturerMap[uniqueKey] = defaultValue;


        const fakeEvent = { target: { value: defaultValue } };
        this.onManufacturerChange(fakeEvent, item, index);
      }
    }

    console.log('Dropdown visibility toggled for', uniqueKey, this.isDropdownVisible[uniqueKey]);
  }



  onManufacturerChange(event: any, item: any, index: number) {
    const selectedManufacturer = event.target.value;
    const originalManufacturer = item.manufacturer;


    this.manufacturerOverrideMap[originalManufacturer] = selectedManufacturer;

    const previousBorderStyle = this.buttonBorderStyle[index];
    this.buttonColorMap[originalManufacturer] = 'btn-mfgs';

    this.buttonBorderStyle[index] = previousBorderStyle || 'btn-mfgs';

    this.isDropdownVisible[index] = false;

    console.log(`UI override: '${originalManufacturer}' → '${selectedManufacturer}'`);
  }

  clearAllManufacturerDetails() {
    this.buttonColorMap = {};
    this.allManufacturerDetails = [];
    this.showDropdownMap = {};
    this.sourceListData.forEach((item: any) => {
      const uniqueKey = item.customerPartNumber;
      this.showDropdownMap[uniqueKey] == false;
      this.buttonColorMap[uniqueKey] = '';
      this.allManufacturerDetails[uniqueKey] = [];
      this.showDropdownMap[uniqueKey] = false;

    });
    this.cdRef.detectChanges();
  }



 Data(dataPrefModal) {
  console.log('Data Preference clicked');
  this.modalRef = this.modalService.open(dataPrefModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  this.modalRef.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

saveDataPreference() {
  console.log('Selected Data Preference:', this.dataPreference);

  this.finalDataList = this.finalDataList.map(item => ({
    ...item,
    dataPreference: this.dataPreference
  }));

  setTimeout(() => {
    this.closeModal();
  }, 100);
}

// Initialize with selected data preferences as an array
dataPreference: string[] = [];

// Function to update selection on checkbox change
onDataPrefChange(option: string, isChecked: boolean) {
  if (isChecked) {
    if (!this.dataPreference.includes(option)) {
      this.dataPreference.push(option);
    }
  } else {
    this.dataPreference = this.dataPreference.filter(item => item !== option);
  }
}


}